import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material"

const DeleteModal = ({ open, handleClose, title, onDelete }) => {

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35vw',
        maxHeight: 650,
        overflow: "hidden",
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
    };
  
    const headerFooterStyle = {
        position: 'sticky',
        zIndex: 1,
        backgroundColor: 'background.paper',
    };    

    const handleModalClose = () => {
        handleClose()
    }

    return (
        <Modal open={open} onClose={handleModalClose}>
            <Box sx={modalStyle}>

                <Box
                    sx={{
                        ...headerFooterStyle,
                        top: 0,
                        p: 2,
                        borderBottom: '1px solid #ccc',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="h6" color={"#d32f2f"}>{title}</Typography>
                    <IconButton onClick={handleClose} size="small">
                        <Close />
                    </IconButton>
                </Box>

                <Box sx={{ overflowY: 'auto', flexGrow: 1, p: 2, display: "flex", justifyContent: "center" }}>
                    <Button variant="contained" color="error" sx={{marginTop: "1em"}} onClick={onDelete}>Delete</Button>
                </Box>

            </Box>

        </Modal>        
    )
}

export default DeleteModal